import { render } from "./MenuContent.vue?vue&type=template&id=71515780&ts=true"
import script from "./MenuContent.vue?vue&type=script&setup=true&lang=ts"
export * from "./MenuContent.vue?vue&type=script&setup=true&lang=ts"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"Shared/components/primitives/menu/MenuContent.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "71515780"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('71515780', __exports__)) {
    api.reload('71515780', __exports__)
  }
  
  module.hot.accept("./MenuContent.vue?vue&type=template&id=71515780&ts=true", () => {
    api.rerender('71515780', render)
  })

}


export default __exports__